import React from 'react'
import PropTypes from 'prop-types'

import useFormField from './useFormField'

const SubmitButton = ({disableOnInvalid, ...props}) => {
  const {
    isDisabled: isButtonDisabled,
    formContext: {dirty, isValid},
  } = useFormField(props)

  const isDisabled =
    isButtonDisabled || !dirty || (disableOnInvalid && !isValid)

  return <button {...props} disabled={isDisabled} type="submit" value={null} />
}

SubmitButton.defaultProps = {
  disableOnInvalid: false,
}

SubmitButton.propTypes = {
  disableOnInvalid: PropTypes.bool,
}

export default SubmitButton
